/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */

"use client";

import { useEffect } from "react";
import { Card } from "@heroui/card";

import AXButton from "@/components/element/AXButton";
import { logError } from "@/services/ErrorLogger";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    /* eslint-disable no-console */
    console.error(error);
    logError(error);
  }, [error]);

  return (
    <div className="flex justify-center items-center w-full py-20 bg-gradient-to-r px-5">
      <Card
        className="text-center p-8 max-w-lg w-full"
        radius="none"
        shadow="lg"
      >
        <h1 className="text-6xl font-extrabold text-ax-secondary mb-4">
          Oops!
        </h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Something went wrong.
        </h2>
        <p className="text-lg text-gray-600 mb-6">
          We encountered an error while processing your request. Please try
          again later.
        </p>
        <div className="flex gap-5 mx-auto">
          <AXButton
            className="bg-ax-secondary text-white hover:bg-ax-secondary/90"
            title="Try Again"
            onPress={reset}
          />
          <AXButton link="/" title="Go to Home" />
        </div>
      </Card>
    </div>
  );
}
